// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CashAppPayAppVerificationFailedEvent
 */
export var CashAppPayAppVerificationFailed = function (_a) {
    var appPackageName = _a.appPackageName, signature = _a.signature;
    return ({
        name: "CashAppPay AppVerification Failed",
        parameters: {
            cdf_entity: "CashAppPay",
            cdf_action: "AppVerification",
            app_package_name: appPackageName !== undefined && appPackageName !== null ? appPackageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            signature: signature !== undefined && signature !== null ? signature.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppPayLineItemsViewEvent
 */
export var CashAppPayLineItemsView = function (_a) {
    var flowToken = _a.flowToken, variant = _a.variant, analyticsKey = _a.analyticsKey;
    return ({
        name: "CashAppPay LineItems View",
        parameters: {
            cdf_entity: "CashAppPay",
            cdf_action: "LineItems",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            analytics_key: analyticsKey !== undefined && analyticsKey !== null ? analyticsKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppPayAuthStartEvent
 */
export var CashAppPayAuthStart = function (_a) {
    var referrerFlowToken = _a.referrerFlowToken, paykitUrl = _a.paykitUrl, origin = _a.origin;
    return ({
        name: "CashAppPay Auth Start",
        parameters: {
            cdf_entity: "CashAppPay",
            cdf_action: "Auth",
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            paykit_url: paykitUrl !== undefined && paykitUrl !== null ? paykitUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppPayAuthGetResponseEvent
 */
export var CashAppPayAuthGetResponse = function (_a) {
    var referrerFlowToken = _a.referrerFlowToken, paykitUrl = _a.paykitUrl, responseCode = _a.responseCode, errorTitle = _a.errorTitle, errorMessage = _a.errorMessage, origin = _a.origin;
    return ({
        name: "CashAppPay Auth GetResponse",
        parameters: {
            cdf_entity: "CashAppPay",
            cdf_action: "Auth",
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            paykit_url: paykitUrl !== undefined && paykitUrl !== null ? paykitUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            response_code: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_title: errorTitle !== undefined && errorTitle !== null ? errorTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppPayAuthDismissErrorEvent
 */
export var CashAppPayAuthDismissError = function (_a) {
    var referrerFlowToken = _a.referrerFlowToken, paykitUrl = _a.paykitUrl, origin = _a.origin;
    return ({
        name: "CashAppPay Auth DismissError",
        parameters: {
            cdf_entity: "CashAppPay",
            cdf_action: "Auth",
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            paykit_url: paykitUrl !== undefined && paykitUrl !== null ? paykitUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashAppPayAuthDismissHalfSheetEvent
 *
 * @deprecated Use `BlockerFlow.Interact.CancelFlow` instead.
 */
export var CashAppPayAuthDismissHalfSheet = function () { return ({
    name: "CashAppPay Auth DismissHalfSheet",
    parameters: {
        cdf_entity: "CashAppPay",
        cdf_action: "Auth",
    }
}); };
